export const RemoteManagementIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 37.5H25M20 45H25M35 37.5H40M35 45H40M31.25 5C39.5 5 43.625 5 46.1875 7.5625C48.75 10.125 48.75 14.25 48.75 22.5V37.5C48.75 45.75 48.75 49.875 46.1875 52.4375C43.625 55 39.5 55 31.25 55H28.75C20.5 55 16.375 55 13.8125 52.4375C11.25 49.875 11.25 45.75 11.25 37.5V22.5C11.25 14.25 11.25 10.125 13.8125 7.5625C16.375 5 20.5 5 28.75 5H31.25Z"
                stroke="url(#paint0_linear_326_3209)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M37.5 20C37.5 21.9891 36.7098 23.8968 35.3033 25.3033C33.8968 26.7098 31.9891 27.5 30 27.5C28.0109 27.5 26.1032 26.7098 24.6967 25.3033C23.2902 23.8968 22.5 21.9891 22.5 20C22.5 18.0109 23.2902 16.1032 24.6967 14.6967C26.1032 13.2902 28.0109 12.5 30 12.5C31.9891 12.5 33.8968 13.2902 35.3033 14.6967C36.7098 16.1032 37.5 18.0109 37.5 20Z"
                stroke="url(#paint1_linear_326_3209)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
                <linearGradient id="paint0_linear_326_3209" x1="32.5862" y1="-22.9412" x2="107.112" y2="64.3351"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_326_3209" x1="31.0345" y1="4.11765" x2="51.5963" y2="36.2237"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};